<template>
  <v-card>
    <v-card-title>Add New MSISDN Price</v-card-title>
    <v-card-text>
      <v-form ref="form" v-model="valid">
        <!-- Name -->
        <v-text-field
            v-model="formData.name"
            label="Name"
            outlined
            dense
        ></v-text-field>

        <!-- Description -->
        <v-textarea
            v-model="formData.description"
            label="Description"
            rows="2"
            outlined
            dense
        ></v-textarea>

        <!-- MSISDN Class -->
        <v-select
            v-model="formData.msisdn_class_id"
            :items="msisdnClasses"
            item-value="id"
            item-title="name"
            label="MSISDN Class"
            :rules="[rules.required]"
            outlined
            dense
        ></v-select>

        <!-- Property Type (Buy/Rent/Transfer) -->
        <v-radio-group
            v-model="formData.msisdn_property_type"
            label="Type"
            :rules="[rules.required]"
            row
        >
          <v-radio label="Buy (One-time)" value="buy"></v-radio>
          <v-radio label="Rent (Periodic)" value="rent"></v-radio>
          <v-radio label="Transfer" value="transfer"></v-radio>
        </v-radio-group>

        <!-- Billing Period (only for Rent) -->
        <v-select
            v-if="formData.msisdn_property_type === 'rent'"
            v-model="formData.billing_period_id"
            :items="billingPeriods"
            item-value="id"
            item-title="name"
            label="Billing Period"
            :rules="formData.msisdn_property_type === 'rent' ? [rules.required] : []"
            outlined
            dense
        ></v-select>

        <!-- Price Value -->
        <v-text-field
            v-model="formData.price_value"
            label="Price"
            type="number"
            step="0.01"
            :rules="[rules.required, rules.positiveNumber]"
            outlined
            dense
        ></v-text-field>

        <!-- Currency -->
        <v-select
            v-model="formData.currency_id"
            :items="currencies"
            item-value="id"
            item-title="name"
            label="Currency"
            :rules="[rules.required]"
            outlined
            dense
        ></v-select>

        <!-- Status -->
        <v-select
            v-model="formData.msisdn_price_status_id"
            :items="msisdnPriceStatuses"
            item-value="id"
            item-title="name"
            label="Status"
            :rules="[rules.required]"
            outlined
            dense
        ></v-select>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="secondary" @click="cancel">Cancel</v-btn>
      <v-btn color="primary" @click="save" :loading="loading" :disabled="!valid">Save</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { log } from "@/composables/useLog";
import { addMsisdnPrice } from "@/composables/useGetMsisdnPricesAPI";

export default {
  name: "AddNewMsisdnPriceEditor",
  props: {
    token: { type: String, required: true },
    msisdnClasses: { type: Array, default: () => [] },
    billingPeriods: { type: Array, default: () => [] },
    currencies: { type: Array, default: () => [] },
    msisdnPriceStatuses: { type: Array, default: () => [] },
  },
  emits: ["MsisdnPriceSavedEvent", "MsisdnPriceCancelEvent"],
  data() {
    return {
      valid: false,
      loading: false,
      formData: {
        name: '',
        description: '',
        msisdn_class_id: null,
        msisdn_property_type: 'buy',
        billing_period_id: null,
        price_value: '',
        currency_id: null,
        msisdn_price_status_id: null,
      },
      rules: {
        required: (v) => !!v || "This field is required",
        positiveNumber: (v) => (v && parseFloat(v) > 0) || "Must be a positive number",
      },
    };
  },
  watch: {
    'formData.msisdn_property_type'(newVal) {
      if (newVal === 'buy') {
        this.formData.billing_period_id = null;
      }
    }
  },
  mounted() {
    // Set default values
    if (this.currencies.length > 0) {
      this.formData.currency_id = this.currencies[0].id;
    }
    if (this.msisdnPriceStatuses.length > 0) {
      const activeStatus = this.msisdnPriceStatuses.find(s => s.name === 'active');
      this.formData.msisdn_price_status_id = activeStatus ? activeStatus.id : this.msisdnPriceStatuses[0].id;
    }
  },
  methods: {
    async save() {
      if (!this.$refs.form.validate()) return;

      this.loading = true;
      log("Saving new MSISDN Price:", this.formData);

      const response = await addMsisdnPrice(this.token, this.formData);

      this.loading = false;

      if (response.error) {
        alert("Error: " + response.message);
      } else {
        this.$emit("MsisdnPriceSavedEvent");
      }
    },
    cancel() {
      this.$emit("MsisdnPriceCancelEvent");
    },
  },
};
</script>
